// extracted by mini-css-extract-plugin
export default {"p":"_98bfd48f20 d7429ed8d2 cfac10a542","clr":"a8578c2e27","dls":"abdcf722ae"};